export default "__VITE_ASSET__BdRLMeX4__"